/**
 * preview.js — the printable / shareable sheets (Preview, Shopping list).
 * A sheet = sections of { key, heading, count, rows: [{ name, meta }] }.
 */
import { isHandled, sortItems } from './items';

/**
 * The open list as a sheet: only what's STILL NEEDED (ticked-off items left out), one
 * section per list in board order. `nameOf(list)` and `ln(name)` localize.
 */
export function boardSheet(items, lists, nameOf, ln) {
  const pool = (items || []).filter(i => !isHandled(i));
  return lists.map(list => {
    const rows = sortItems(pool.filter(i => i.category === list.id));
    return {
      key: list.id,
      heading: `${list.icon} ${nameOf(list)}`,
      count: rows.length,
      rows: rows.map(r => ({ name: ln(r.name), meta: r.qty })),
    };
  }).filter(s => s.rows.length);
}

/** Total rows across a sheet's sections. */
export const sheetCount = sections => sections.reduce((n, s) => n + s.rows.length, 0);
